import factory from '@helpers/storeFactories/factory';
import { apiService } from '@api';

const STORE_NAME = 'bookingStatuses';

const store = factory.createStore(STORE_NAME, {
    get: apiService.bookingStatuses.get,
});

export default store;
